import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'
import { CardBlock } from 'components/features/pfm/Blocks/Blocks'

const SGBlocks = () => (

  <section className={ styles.sgSection }>
    <Caption text='overlay' />

    <CardBlock corners='none' withPadding />
    <Caption text='card' />
  </section>
)
// <div className='insight-card'>
//   <div className='container-card insight'>
//       <div className = 'insight-category'>tracker</div>
//       <h6 className='title-insight'>
//         You spent too much on restaurant
//       </h6>
//       <p className='body-insight'>
//         You spend more on restaurants than you peers. You should try to keep it under 15% of your income, which is $200. We can help you do that.
//       </p>
//       <ul className='insight-action-wrapper'>
//         <li className='insight-action'>
//           <a className='link' href=''>track</a>
//         </li>
//         <li className='insight-action'>
//           <a className='link' href=''>learn more</a>
//         </li>
//         <li className='insight-action'>
//           <a className='link' href=''>skip</a>
//         </li>
//       </ul>
//   </div>
//   <div className='container-card insight-faux'></div>
//   <div className='container-card insight-faux'></div>
//   <div className='container-card insight-faux'></div>
// </div>
// <div className='caption'>insight card</div>
// <Caption text='insight card' />
// <Caption text='card' />
//   <div className='tabs-wrapper'>
//     <ul className='tabs'>
//       <li data-tab='one' className='tab _active'>Mortgage</li>
//       <li data-tab='two' className='tab'>Credit Cards</li>
//       <li data-tab='three' className='tab'>Auto Loan</li>
//       <li data-tab='four' className='tab'>Student Loan</li>
//     </ul>
//     <ul className='tab-content-wrapper'>
//       <li data-tab-content='one' className='tab-content'>
//           Content within tab one. At aliquet odio. Nunc luctus ligula enim, ut fringilla est condimentum ut. Vestibulum ante ipsum primis in faucibus orut fringilla estci luctus et ultrices posuere.
//       </li>
//       <li data-tab-content='two' className='tab-content _hidden'>
//           Content within tab two. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla. Maecenas sed diam eget risus varius blandit sit amet non magna. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna.
//       </li>
//       <li data-tab-content='three' className='tab-content _hidden'>
//           Content within tab three. At aliquet odio. Nunc luctus ligula enim, ut fringilla est condimentum ut. Vestibulum ante ipsum primis in faucibus orut fringilla estci luctus et ultrices posuere.
//       </li>
//       <li data-tab-content='four' className='tab-content _hidden'>
//           Content within tab four.At aliquet odio. Etiam porta sem malesuada magna mollis euismod. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Aenean lacinia bibendum nulla sed consectetur.
//       </li>
//     </ul>
//   </div>
//   <Caption text='tabs' />

//   <div className='pagination'>
//     <ul>
//       <li className='first '>&nbsp;</li>
//       <li className='prev '>&nbsp;</li>
//       <li className='pagination-item dots '>...</li>
//       <li className='pagination-item '>5</li>
//       <li className='pagination-item '>6</li>
//       <li className='pagination-item _active '>7</li>
//       <li className='pagination-item '>8</li>
//       <li className='pagination-item '>9</li>
//       <li className='pagination-item dots'>...</li>
//       <li className='next '>&nbsp;</li>
//       <li className='last '>&nbsp;</li>
//     </ul>
//   </div>
//   <Caption text='pagination' />

export default SGBlocks

